import React from 'react';

import dayjs from 'dayjs';

import { Wrapper } from './styles';

interface TimestampProps {
    date?: string | null;
}

export const Timestamp = ({ date }: TimestampProps) => {
    if (!date) return null;

    const _date = dayjs(new Date(date));
    const _now = dayjs();

    const isJustNow = _now.diff(date, 'minutes') < 10;
    const isToday = _now.diff(date, 'days') < 1;
    const isThisYear = _now.year() == _date.year();

    let dateTimeAgo = _date.format('MMM D YYYY');

    if (isJustNow) {
        dateTimeAgo = 'Just now';
    } else if (isToday) {
        dateTimeAgo = _date.fromNow();
    } else if (isThisYear) {
        dateTimeAgo = _date.format('MMM D');
    }

    return <Wrapper title={_date.format('MMM D, YYYY h:mm A')}>{dateTimeAgo}</Wrapper>;
};
